import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";
import { borderRadius, color, fontFamily, fontSize, fontWeight, style, styled, textAlign, width } from "@mui/system";
import companylogo from "../../common/assests/companylogo.png";
import emailIcon from "../../common/assests/emailicon.png";
import passwordIcon from "../../common/assests/password.png";
import "./SignUp.css";
import ForgotPassword from "../forgot/ForgotPassword";
import OtpModal from "../forgot/OtpModal";
import ConfirmPassModal from "../forgot/ConfirmPassModal";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { handleSignUp } from "../../api";
import { useDispatch } from "react-redux";
import { login } from "../../redux/userSlice";
import CustomBtn from "../../common/customButton/CustomBtn";
import Loader from "../../common/loader/Loader";
import CloseEyeIcon from "../../common/assests/eclose.svg";
import OpenEyeIcon from "../../common/assests/eopen.svg";
import CustomModal from "../../common/customModal/CustomModal";
import { generateToken, messaging } from "../../firebase";
import { getToken } from "firebase/messaging";
// import configuration from "../../config/Config";


const SignUp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [refId, setRefId] = useState();

  const handleClickShowPassword = () => setShowPassword((prev) => !prev);

  const handleOpenModal = (tabIndex = 0) => {
    setActiveTab(tabIndex);
    setOpenModal(true);
  };

  const handleNext = (newRefId) => {
    setRefId(newRefId); 
    setActiveTab(1); 
  };

  const [tok,setTok]=useState('')

  const notificarionToken=async()=>{
      try {
        const permission = await Notification.requestPermission();
       
        if (permission === "granted") {
          // console.log("messgae");
          
          const notifytoken = await getToken(messaging, {
            vapidKey:'BBOMlQyxZLRFaRUy0biSBHSgP1Mk8KvPfhp_o0_k7zr7c1Hg6d5xIR5OzCYQfyuT2sQisu8GbQHv6JCHI8iSOYc',
          });
          // resolve(notifytoken);se
          setTok(notifytoken)
        }
      } catch (error) {
        console.log("reje",error);
        
        // reject(error);
      }
  //   });
  // };
  } 

  
  useEffect(() => {
    
    notificarionToken()
    
 
   }, [])
   

  const handleCloseModal = () => setOpenModal(false);


  const handleBackToPrevious = () => {
    if (activeTab > 0) setActiveTab((prevTab) => prevTab - 1);
  };


  const validateEmail = (email) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  };
 
  const handleSignIn = async () => {
  
    if (!credentials.email || !credentials.password) {
      toast.warning("Email and Password required");
      return;
    }
      
    if (!validateEmail(credentials.email)) {
      toast.error("Please provide a valid email address.");
      return;
    }
    try {
      setLoading(true);
      setBtnDisable(true);
      const loginUser = await handleSignUp({credentials,tok});
      dispatch(login({ ...loginUser.data, token: loginUser.token }));
      toast.success(loginUser.message);
      navigate("/dashboard");
      setBtnDisable(false);
    } catch (err) {
      
      
      setBtnDisable(false);
      toast.error(err?.data?.message);
      setLoading(false)
    } 
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="signup-container outer">
      {loading && <Loader variant="form" />}
      <Box className="signup-box">
        <StyledCard>
          <CardContent className="signup-card-content">
            <Box className="signup-logo">
              <img src={companylogo} alt="logo" className="signup-logo-img" />
            </Box>

            {/* <Box className="signup-welcome"> */}
             {/* <div style={{textAlign:'left'}}> */}
             <Typography className="signup-welcome-text">Hello, Welcome Back</Typography>
             {/* </div> */}
              {/* <Typography className="signup-subtext"></Typography> */}
            {/* </Box> */}

             <Box sx={{ width: "90%", marginTop: "20px" }}>
              <Typography
                sx={{
                  marginBottom: "8px",
                  textAlign: "left",
                  marginLeft: "20px",
                  fontSize: "17px",
                  fontWeight: "600",
                  fontFamily: "Heebo",
                }}
              >
                Email
              </Typography>
              <TextField
                fullWidth
                type="email"
                placeholder="Type your email"
                name="email"
                value={credentials.email}
                onChange={handleInputChange}
                sx={{
                  color:'black !important',
                  borderRadius: "28px",
                 
                  // border: "1px solid #362B24",
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={emailIcon}
                        alt="email-logo"
                        className="img-fluid"
                        style={{ width: "20px" }}
                      />
                    </InputAdornment>
                  ),
                  style: { borderRadius: "28px" },
                }}
              />
            </Box>

           <Box sx={{ width: "90%", margin: "12px" }}>
                         <Typography
                           sx={{
                             marginBottom: "8px",
                             textAlign: "left",
                             marginLeft: "20px",
                             fontSize: "17px",
                             fontWeight: "600",
                             fontFamily: "Heebo",
                           }}
                         >
                           Password
                         </Typography>
                         <TextField
                           fullWidth
                           type={showPassword ? "text" : "password"}
                           placeholder="Type your Password"
                           name="password"
                           value={credentials.password}
                           onChange={handleInputChange}
                           sx={{
                             borderRadius: "28px",
                             // opacity: "0.3",
                             // border: "1px solid #362B24",
                             outline:"none !important"
                           }}
                           InputProps={{
                             startAdornment: (
                               <InputAdornment position="start">
                                 <img
                                   src={passwordIcon}
                                   alt="password-logo"
                                   className="img-fluid"
                                   style={{ width: "20px",}}
                                 />
                               </InputAdornment>
                             ),
                              endAdornment: (
                                 <InputAdornment position="end">
                                   <img
                                     src={showPassword ? OpenEyeIcon : CloseEyeIcon}
                                     alt="toggle-password-visibility"
                                     onClick={handleClickShowPassword}
                                     style={{ width: "20px", cursor: "pointer",opacity:'0.4' }}
                                   />
                                 </InputAdornment>
                               ),
                             style: { borderRadius: "28px" },
                           }}
                           
                         />
                       </Box>


            <Box className="signup-forgot-password">
              <Typography className="signup-forgot-password-text" onClick={() => handleOpenModal(0)}>
                Forgot Password?
              </Typography>
            </Box>

            <Box className="signup-button-wrapper">
              <CustomBtn onClick={handleSignIn} text="Sign in" disable={btnDisable} />
            </Box>

          </CardContent>
        </StyledCard>
      </Box>

      <CustomModal open={openModal} onClose={handleCloseModal}>
        {activeTab === 0 && 
        <ForgotPassword setActiveTab={setActiveTab} onBack={handleCloseModal}  onNext={handleNext} />}
        
        {activeTab === 1 && (
          <OtpModal setActiveTab={setActiveTab} onBack={handleBackToPrevious} otp={otp} setOtp={setOtp} refId={refId}  />
        )}
        {activeTab === 2 && (
          <ConfirmPassModal  onSubmit={handleCloseModal} onBack={handleBackToPrevious} refId={refId}  />
        )}
      </CustomModal>


    </div>
  );
};

const StyledCard = styled(Card)(({ theme }) => ({
  width: "100%",
  maxWidth: "480px",
  borderRadius: "32px",
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
  [theme.breakpoints.down("sm")]: { minHeight: "auto" },
}));

export default SignUp;
